import type { LucideIcon } from "lucide-react";
import {
    Activity,
    Box,
    Check,
    CheckSquare,
    CircleHelp,
    Clock,
    FileSearch,
    FileStack,
    FileText,
    Gavel,
    LayoutGrid,
    ListChecks,
    Star,
    Target,
    User,
} from "lucide-react";

/**
 * Iconos permitidos en `bpm_lateral_options_v2[].items[].icon` (nombre PascalCase devuelto por el backend).
 * Se registran de forma estática en vez de usar `DynamicIcon` de `lucide-react/dynamic`, que obliga a Vite a
 * emitir un chunk por cada icono de lucide (~1,600 archivos en `assets`). Si el backend agrega un icono nuevo,
 * hay que registrarlo aquí; de lo contrario se muestra `CircleHelp`.
 */
const sidebarIcons: Record<string, LucideIcon> = {
    Activity,
    Box,
    Check,
    CheckSquare,
    Clock,
    FileSearch,
    FileStack,
    FileText,
    Gavel,
    LayoutGrid,
    ListChecks,
    Star,
    Target,
    User,
};

export const getSidebarIcon = (name: string): LucideIcon => sidebarIcons[name] ?? CircleHelp;
